// export const baseUrl = 'https://amardairyfarm-backend.onrender.com';
// export const webBaseUrl = 'https://amardairyfarm-backend.onrender.com';


// Production
export const baseUrl = 'https://api.amardairyfarm.com';
export const webBaseUrl = 'https://api.amardairyfarm.com';
export const IS_PRODUCTION = true;

// export const baseUrl = 'http://192.168.0.194:3000';
// export const webBaseUrl = 'http://192.168.0.194:3000';
// export const IS_PRODUCTION = false;

export const NO_SPACES_PATTERN = /^\S*$/;
export const SPACE_REGEX = /\s/g;
export const REGEX_NUMERIC = /[^0-9]/g;
export const REGEX_DECIMAL = /[^0-9.]/g; // Allows digits and decimal point
export const ONLY_ALPHABETS_NO_SPACE = new RegExp(/[^a-zA-Z]+/g);
export const ONLY_ALPHABETS_WITH_SPACE = /[^a-zA-Z\s]/g;
export const ALPHANUMERIC_WITHOUT_SPACE = /[^a-zA-Z0-9]/g;
export const ALPHANUMERIC_WITH_SPACE = /[^a-zA-Z0-9\s]/g;
export const USERNAME_AT_FILTER_REGEX = /[^a-zA-Z@]/g;

export const MIXPANEL_TOKEN = '321f6d4aae48d473b96aebd942ed1c83';



